import styled from 'styled-components';
import { CSVLink } from 'react-csv';
import Button from '../../StoraEnsoComponents/Button';
import { ReactComponent as FileCsvSvg } from '../../../assets/icons/file-csv.svg';

const FileIcon = styled(FileCsvSvg)``;

function ExportTableToCSV({tableData, headers}) {
console.log(headers)
console.log(tableData)
  return (
    <CSVLink data={tableData} headers={headers.label} filename="droneTable.csv" target="_blank">
      <Button icon={<FileIcon />} onClick={() => {}} size="sm">
        Export to CSV
      </Button>
    </CSVLink>
  );
}

export default ExportTableToCSV